import { Styles } from 'shared/types';
import { colors } from 'shared/utils';

export const Loader: Styles = {
  color: colors.blueberry,
};
export const DownloadButton: Styles = {
  width: 220,
};
